import { render } from "./SettingsPanelAutomation.vue?vue&type=template&id=29770c3e"
import script from "./SettingsPanelAutomation.vue?vue&type=script&lang=ts"
export * from "./SettingsPanelAutomation.vue?vue&type=script&lang=ts"

import "./SettingsPanelAutomation.vue?vue&type=style&index=0&id=29770c3e&lang=scss"
script.render = render

export default script